/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { ClearThesisReactionResponse, ClearThesisReactionVars } from '../openapi-types.gen.js';

export type { ClearThesisReactionResponse, ClearThesisReactionVars } from '../openapi-types.gen.js';

export const useClearThesisReaction = createMutationHook<ClearThesisReactionVars, ClearThesisReactionResponse, unknown>({
  specName: 'useClearThesisReaction',
  path: '/v1/theses/{signature}/reaction',
  method: 'DELETE',
  resolveUrl: (vars: ClearThesisReactionVars) => `/v1/theses/${vars.signature}/reaction`,
  
  parseResponse: (raw: unknown): ClearThesisReactionResponse => raw as ClearThesisReactionResponse,
  optimistic: [{
    queryKey: ['theses', 'detail'],
    apply: (prev: any, vars: ClearThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyThesisReactionOptimistic as unknown as (prev: any, vars: ClearThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }, {
    queryKey: ['theses', 'list'],
    apply: (prev: any, vars: ClearThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyThesisReactionOptimistic as unknown as (prev: any, vars: ClearThesisReactionVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
